import { AddTicket, BillingSchemaWithoutBusinessName } from "@ac-expo/api";
import { z } from "zod";

export const BuyerInformationsSchema = z
  .object({
    email: z.string().email("Veuillez entrer un email"),
    discountCodes: z.array(z.string()).optional(),
  })
  .merge(BillingSchemaWithoutBusinessName);

export const defaulBuyerInformationsValues = {
  email: "",
  address: {
    firstName: "",
    lastName: "",
    address1: "",
    address2: "",
    city: "",
    zipCode: "",
    countryCode: "",
  },
  acceptedTerms: false,
  organisers: [],
  structures: [],
  discountCodes: [],
};

export type BuyerInformationsForm = z.infer<typeof BuyerInformationsSchema>;

export type BuyerInformationsFormNewTicketingOrder = BuyerInformationsForm & {
  tickets: AddTicket[];
  badges: AddTicket[];
};
